/**
 * Leaderboard places for the Bake Off League. Players arrive sorted by
 * total, highest first. Equal totals share a place, and the next total
 * takes the place after everyone above it: 7, 7, 7, 5 is 1, 1, 1, 4.
 */
export function sharedPlaces(totals: readonly number[]): number[] {
  return totals.map((t, i) => {
    let place = i;
    while (place > 0 && totals[place - 1] === t) place -= 1;
    return place + 1;
  });
}
